export default function auth({
    next,
    router
  }) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || !user.is_active) {
      return router.push({
        path: '/dashboard'
      });
    }
    if (!user.private_fleet) {
      return router.push({
        path: '/dashboard'
      });
    }
    if (!localStorage.getItem('token')) {
      return router.push({
        path: '/'
      });
    }
    return next();
  }